import lwsLogo from "../images/logo.png";
import {useSelector} from "react-redux";

export default function Nav({showProductOrCart, handleChange}) {
    const cartItems = useSelector((state) => state.cart);
    const cartItemCount = cartItems.reduce((prev, curr) => prev+curr.quantity, 0);
    
    return (
        <nav className="bg-[#171C2A] py-4">
            <div className="navBar">
                <a href="#home">
                    <img src={lwsLogo} alt="LWS" className="max-w-[140px]" />
                </a>

                <div className="flex gap-4">
                    <a href="#home" className="navHome" id="lws-home" onClick={() => handleChange(true)}>
                        Home
                    </a>
                    <a href="#cart" className="navCart" id="lws-cart" onClick={() => handleChange(false)}>
                        <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
                        <span id="lws-totalCart">{cartItemCount}</span>
                    </a>
                </div>
            </div>
        </nav>
    );
}
